const imageSize = (size: number) => size * 2

export const personPhotoSrc = (photo: { url: string }, size: number) =>
  `https:${photo.url}?fit=thumb&w=${imageSize(size)}&h=${imageSize(size)}&fm=webp`
